<template>
  <div class="component-wrapper" style="border-radius: 20px">
    <div v-if="loader" style="position: relative; width: 100vw; height: 100vh">
      <v-progress-circular
        style="
          position: abolute;
          z-index: 999;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -100%);
        "
        size="100"
        indeterminate
        color="important"
      >
      </v-progress-circular>
    </div>
    <Card
      v-else
      :showCard="true"
      :cardImg="`https://chalkidiki.mobics.gr/${tour.main_image}`"
      :cardColor="'poi_background'"
      topDistance="(100vh - 450px)"
      bottomDistance="600px"
    >
      <template #background>
        <div class="map-container">
          <GmapMap
            :center="{
              lat: parseFloat(tour.latitude),
              lng: parseFloat(tour.longitude),
            }"
            :zoom="15"
            :options="mapOptions"
            class="googleMap"
            ref="mapRef"
            @click="$router.push('/home')"
          >
            <gmap-custom-marker
              :marker="{
                lat: parseFloat(tour.latitude),
                lng: parseFloat(tour.longitude),
              }"
              :zIndex="2"
              class="mt-2"
              ><button>
                <img
                  v-if="tour.multi_day"
                  src="@/assets/icons/map/Tour POI Icon.svg"
                  style="height: 32px; width: auto"
                />
                <img
                  v-else
                  src="@/assets/icons/map/Colony POI Icon.svg"
                  style="height: 32px; width: auto"
                  @click="onTourClick(tour)"
                />
              </button>
            </gmap-custom-marker>
          </GmapMap>
        </div>
      </template>

      <template #title="{ step }">
        <!-- title container  -->
        <div :class="titleContainerStyle(step)">
          <div
            class="title-text white--text text-center"
            :class="titleStyle(step)"
          >
            {{ tour.name }}
          </div>

          <div
            v-if="step != 3 && step != 0"
            class="title-text white--text text-center py-1 route_caption"
          >
            {{ currentTour.subtitle }}
          </div>

          <!-- pois count & distance -->
          <div
            v-if="step != 3 && step != 0 && tour.multi_day"
            class="d-flex align-center justify-center mt-12"
          >
            <div class="d-flex align-center">
              <img
                src="@/assets/icons/poi-white.svg"
                style="height: 20px; width: auto"
              />
              <div class="white--text ml-1">
                {{ tour.days[0].pois.length }}
              </div>
            </div>
            <div
              style="
                padding-top: 10px;
                height: 20px;
                width: 1px;
                margin: 0 10px;
              "
              class="white"
            ></div>
            <div class="d-flex align-center">
              <img
                src="@/assets/icons/tour.svg"
                style="height: 20px; width: auto"
              />
              <div class="white--text ml-1">{{ time }}</div>
            </div>
          </div>
        </div>
        <!-- title -->

        <!-- top controllers -->
      </template>

      <template #content="{ step }">
        <div
          v-if="step != 0"
          class="text_background px-10 pt-10 pb-16 d-flex flex-column"
          :class="
            step == 3 && $vuetify.breakpoint.xs
              ? 'expanded'
              : step == 3 && !$vuetify.breakpoint.xs
              ? 'web'
              : ''
          "
        >
          <TextSection
            :item="{
              paragraph: tour.description,
            }"
          ></TextSection>

          <TextSection
            v-if="tour.multi_day"
            :item="{
              hasTitle: 'true',
              title: $t('tour_route'),
              duration: time,
              distance: distance,
              pois: tour.days[1].pois.length,
              paragraph: tour.details_2
                ? tour.details_2
                : 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Deleniti ut corrupti dignissimos, quisquam sequi quam alias labore dolorem, error, nam optio perspiciatis nihil. Fugit quidem aut placeat magni, laudantium neque?Est ut qui hic rerum dolores, dolore sequi vero id magni reiciendis facilis dicta nulla tempore tempora aliquam, corporis numquam laudantium possimus rem molestias quisquam autem similique incidunt. Voluptate, et?',
              hasButton: true,
              buttonText: $t('buttons.start_tour'),
              buttonIcon: 'Play button.png',
              hasButtonAction: true,
              path: 'route',
            }"
          ></TextSection>

          <TextSection
            class="pb-10"
            v-if="tour.multi_day"
            :item="{
              hasTitle: 'true',
              title: $t('tour_pois'),
              pois: tour.days[0].pois.length,
              paragraph: tour.details
                ? tour.details
                : 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Deleniti ut corrupti dignissimos, quisquam sequi quam alias labore dolorem, error, nam optio perspiciatis nihil. Fugit quidem aut placeat magni, laudantium neque?Est ut qui hic rerum dolores, dolore sequi vero id magni reiciendis facilis dicta nulla tempore tempora aliquam, corporis numquam laudantium possimus rem molestias quisquam autem similique incidunt. Voluptate, et?',
              isLast: true,
              hasButton: true,
              buttonText: $t('buttons.view_pois'),
              buttonIcon: 'map.png',
              hasButtonAction: true,
              path: 'pois',
            }"
          ></TextSection>
        </div>
      </template>

      <template #bottomNavigation="{ step }">
        <div
          v-if="
            step != 1 && step != 0 && tour.multi_day && $vuetify.breakpoint.xs
          "
          class="bottom_navigation primary d-flex align-center justify-space-between"
        >
          <div
            class="primary white--text d-flex align-center justify-space-between"
            style="
              text-align: center;
              height: 35px;
              width: 170px;
              z-index: 100;
              border-radius: 18px;
              font-size: 17px;
              border: 1px solid white !important;
            "
            @click="$router.push(`/pois`)"
          >
            <span class="pl-4 mr-12"> {{ $t("buttons.map") }} </span>

            <div class="white mr-1" style="border-radius: 100px; height: 24px">
              <img
                src="@/assets/icons/map/map_closed.png"
                style="height: 15px; width: auto"
                class="mx-1 my-1"
              />
            </div>
          </div>

          <div
            class="primary white--text d-flex align-center justify-space-between"
            style="
              width: 170px;

              text-align: center;
              height: 35px;
              z-index: 100;
              border-radius: 18px;
              font-size: 17px;
              border: 1px solid white !important;
            "
            @click="$router.push(`/route`)"
          >
            <span class="pl-4 mr-7"> {{ $t("buttons.tour") }} </span>

            <img
              src="@/assets/icons/Isolation_Mode.png"
              style="height: 27px; width: auto"
              class="mr-1"
            />
          </div>
        </div>

        <!-- <transition name="fadeInUp">
          <div
            v-if="step != 1 && step != 0"
            class="bottom_navigation primary d-flex align-center justify-space-between"
          >
            <img
              src="@/assets/icons/Map button.svg"
              style="height: 35px; width: auto"
              @click="onOpenMap"
            />
            <img
              src="@/assets/icons/Tour button.svg"
              style="height: 35px; width: auto"
              @click="onStartRoute"
            />
          </div>
        </transition> -->
      </template>
    </Card>
  </div>
</template>

<script>
import axios from "axios";
import mapStyles from "@/utils/mapStyles.json";
import GmapCustomMarker from "vue2-gmap-custom-marker";
import Card from "@/components/Utils/Card.vue";
import TextSection from "@/components/Utils/TextSection.vue";
import { mapMutations, mapState } from "vuex";
import { AppLauncher } from "@capacitor/app-launcher";

export default {
  components: {
    Card,
    TextSection,
    "gmap-custom-marker": GmapCustomMarker,
  },

  beforeRouteEnter(to, from, next) {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 700);

    next();
  },

  async created() {
    try {
      // if (
      //   this.currentTour &&
      //   this.currentTour.id == this.$route.params.tour_id
      // ) {
      //   this.tour = this.currentTour;
      //   return;
      // }

      this.loader = true;
      axios.defaults.headers.common[
        "Accept-Language"
      ] = `${this.mobileLang.code}`;
      const res = await axios.get(
        `${process.env.VUE_APP_BASE_URL}/paths/${this.$route.params.tour_id}`
      );

      this.tour = res.data.path;
      this.setCurrentTour(this.tour);
      this.loader = false;
      // const res = await axios.get()
      // this.$route
    } catch (e) {
      console.log(e);
    }
  },

  data() {
    return {
      tour: null,
      loader: false,
      mapOptions: {
        directionsService: null,
        directionsRenderer: null,
        zoomControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        keyboardShortcuts: false,
        gestureHandling: "greedy",
        minZoom: 8,
        maxZoom: 15,
        styles: mapStyles,
      },
      route: {},
      paragraph:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus, enim      molestiae quisquam voluptatem aut, recusandae libero repellat nisi quidem      rem, earum totam laudantium dolorem. Nulla quae praesentium sit minus      inventore. Laboriosam error saepe iusto totam et laudantium possimus culpa      quae facilis reprehenderit cupiditate aspernatur, blanditiis ab      accusantium perferendis incidunt.",
    };
  },

  computed: {
    ...mapState({
      currentTour: (state) => state.routes.currentTour,
      insets: (state) => state.base.insets,
      mobileLang: (state) => state.base.mobileLang,
    }),

    main() {
      return `top: calc(${
        this.insets?.top ? this.insets?.top + "px" : "0px"
      } + 0px)`;
    },

    distance() {
      const digits = `${this.tour.length_chilometer.split(".")[0]}`;
      return `${digits.split("").join(",")} km`;
    },

    time() {
      return `${this.tour.length_chilometer.split(".")[1]}’`;
    },
  },

  methods: {
    ...mapMutations(["setCurrentTour"]),
    async onOpenEfales() {
      await AppLauncher.openUrl({
        url: "efales://",
      });
    },

    onOpenMap() {
      this.$router.push(`/pois`);
    },

    onStartRoute() {
      this.$router.push(`/route`);
    },

    //styling methods
    titleContainerStyle(step) {
      if (step == 3) return "title-container shrinked";
      return "title-container";
    },

    backgroundImageStyle(step) {
      if (step == 3) return "background-image shrinked";
      return "background-image ";
    },

    titleStyle(step) {
      if (step == 3 || step == 0) {
        return "route_title shrinked";
      }
      return "route_title";
    },

    subTitleStyle(step) {
      if (step == 3) {
        return "route_subtitle shrinked";
      }
      return "route_subtitle";
    },

    captionStyle(step) {
      if (step == 3) {
        return "route_caption shrinked";
      }
      return "route_caption";
    },
    //styling methods
  },
};
</script>

<style scoped>
.title-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -47%);
  width: 100vw;
}

.title-container.shrinked {
  transform: translate(-50%, -60%);
}

.route_title {
  font-weight: 400;
  font-size: 58px;
  transition: font-size 0.5s ease;
  line-height: 75px;
}

.route_title.shrinked {
  font-size: 32px;
  line-height: 45px;
}

.route_subtitle {
  font-weight: 400;
  font-size: 40px;
  transition: font-size 0.5s ease;
  line-height: 35px;
}

.route_subtitle.shrinked {
  font-size: 25px;
  font-weight: 300;
  overflow-x: visible;
  white-space: nowrap;
  word-spacing: 10px;
}

.route_caption {
  font-weight: 300;
  font-size: 28px;
  transition: font-size 0.5s ease;
  /* line-height: 30px; */
}

.text_background.expanded {
  margin-top: 125px;
  min-height: calc(135vh - 125px);
  /* padding-bottom: 300px; */
}

.text_background.web {
  margin-top: 45px;
  min-height: calc(135vh - 125px);
  /* padding-bottom: 300px; */
}

.bottom_navigation {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  border-top-left-radius: 35px;
  border-top-right-radius: 35px;
  padding: 27px 28px;
}

.map-container {
  position: fixed;
  top: 0;
  z-index: 1;
  height: 10px;
  width: 100vw;
}

.googleMap {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 0;
  height: 100vh;
}

@keyframes fadeInUp {
  from {
    transform: translate3d(0, 89px, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.fadeInUp-enter-active {
  animation: fadeInUp 0.6s ease;
  transition: opacity 0.6s ease;
}
.fadeInUp-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.route_caption {
  font-weight: 250;
  font-size: 18px;
  transition: font-size 0.5s ease;
  white-space: nowrap;

  /* line-height: 30px; */
}
</style>
